
import { ServiceOverviewSection } from "@/components/services/ServiceOverviewSection";
import { BenefitsCheckList } from "@/components/services/BenefitsCheckList";
import { laserDentistryData } from "./laserDentistryData";

export const LaserDentistryOverview = () => {
  return (
    <ServiceOverviewSection
      title="Modern Dental Laser Technology"
      description={
        <>
          <p className="mb-4">
            At Asrani Dental in Sadar, Nagpur, our laser dentistry services use cutting-edge technology to provide more comfortable, precise, and efficient treatments for various dental conditions.
          </p>
          <BenefitsCheckList benefits={laserDentistryData.benefits} />
        </>
      }
      imageSrc="/lovable-uploads/ebdbfff0-7237-4687-a102-2cecfdce9ba9.png"
      imageAlt="Laser Dentistry at Asrani Dental Clinic, Sadar, Nagpur"
    />
  );
};
